// extracted by mini-css-extract-plugin
module.exports = {"container":"MainLayout_container__1Etiv"};